import { Ref, watch } from "vue"
import { useBimVertailu } from "@/methods/bimComposables"
import * as malliIkkuna from "./malliIkkuna"

/** Liitos Vahdin nakymista mallikatselimeen.
 *
 *  Kokoaa yhteen kaksi kysymysta jotka jokainen linkkikohta tarvitsee:
 *  onko tama tila mallissa, ja nayta se siella. Linkki renderoidaan vain
 *  mallista loytyville tiloille, joten **linkin olemassaolo kertoo itsessaan
 *  loytyyko tila mallista** — erillista merkintaa tai varia ei tarvita.
 *
 *  Tama on myos ainoa paikka joka tyontaa paivittyneen vertailun avoimeen
 *  ikkunaan. Ala kopioi `watch`ia komponentteihin: yksi lahde riittaa, ja
 *  kaksi rinnakkaista lahettaisi saman datan kahdesti.
 *
 *  Sijaitsee `components/hanke/malli/`:ssa eika `methods/`:ssa, koska se
 *  riippuu `malliIkkuna.ts`:sta — methods -> components olisi vaara suunta.
 */
export function useMalliLinkki(hankeId: Ref<number | undefined>) {
    const vertailu = useBimVertailu(hankeId)

    /** Ennen kuin vertailu on haettu tama on aina false, jolloin tunnukset
     *  ovat tavallista tekstia. Se on oikea vaste: emme voi viela tietaa
     *  loytyyko tila mallista.
     *
     *  Tunnus otetaan vastaan valinnaisena, koska Vahdin API-tyypissa
     *  `TilaResponse.tilatunnus` on `string | undefined`. Tunnukseton tila
     *  ei voi osua malliin, joten se ei myoskaan saa linkkia. */
    const mallissa = (tilatunnus?: string) =>
        !!tilatunnus && vertailu.tilaTunnuksella.value.has(tilatunnus)

    /** HUOM: ei `await`ia ennen `malliIkkuna.avaa()`:ta. window.open on
     *  kutsuttava synkronisesti klikkauskasittelijassa, tai selain tulkitsee
     *  avauksen ei-kayttajalahtoiseksi ja estaa sen. */
    const avaaMalli = () => {
        malliIkkuna.avaa()
        malliIkkuna.asetaData(vertailu.compliance.value)
    }

    const naytaMallissa = (tilatunnus?: string) => {
        if (!tilatunnus) return
        avaaMalli()
        malliIkkuna.valitseTila(tilatunnus)
    }

    watch(vertailu.compliance, (c) => malliIkkuna.asetaData(c))

    return { ...vertailu, mallissa, avaaMalli, naytaMallissa }
}
